// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3Yv2w","modalFooterButton":"ModalNotes_modalFooterButton__NHIvU"};